export const ConfirmationPreSubmitModalTestIds = {
  WRITTEN_CHECKBOX: 'confirmation-pre-submit-modal.written-checkbox',
  VERBAL_CHECKBOX: 'confirmation-pre-submit-modal.verbal-checkbox',
  OPTIONS_SELECT: 'confirmation-pre-submit-modal.options-select',
  getBureauCheckboxId: bureauKey => `confirmation-pre-submit-modal.bureau-${bureauKey}-checkbox`,
  DECLINE_BUTTON: 'confirmation-pre-submit-modal.decline-button',
  ACCEPT_BUTTON: 'confirmation-pre-submit-modal.accept-button',
};
